import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import PlanImpact from '../../PlanImpact/PlanImpactContainer';
import AdvForm from '../../../CommonComponents/AdvForm';
import Footer from '../../Footer/FooterContainer';
import Loading from '../../Loading/LoadingView';
import { isNumeric, isUuid, createCustomPropType, isNumericFormatted } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import AdvInput, { advInputTextChanged } from '../../../CommonComponents/AdvInput';
import AdvInputWrapper from '../../../CommonComponents/AdvInputWrapper';

class PriceChangesChangesView extends Component {
  constructor() {
    super();
    this.onPriceBlur = this.onPriceBlur.bind(this);
  }
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;
    fetchData(clientId, fpId, goalId, whatIfTemplate.WhatIfType);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(previousProps) {
    const {
      clientId, fpId, goalId, whatIf, fetchPlanImpact, whatIfTemplate,
    } = this.props;

    const impactTriggerProps = ['whatIf'];

    if (
      !isEqual(
        pick(this.props, impactTriggerProps),
        pick(previousProps, impactTriggerProps),
      )
    ) {
      fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
    }
  }

  onPriceBlur(valueArg) {
    const {
      goalId, clientId, whatIfTemplate, storeData,
    } = this.props;
    let value = valueArg;
    if (isNumericFormatted(valueArg)) {
      if (typeof valueArg === 'string') {
        value = +valueArg.replace(/[,]/g, '');
      }
    } else {
      value = 0;
    }
    advInputTextChanged(
      clientId,
      storeData(goalId, whatIfTemplate.WhatIfType),
      'WhatIf.Price',
    )(value);
  }

  render() {
    const {
      goalId,
      clientId,
      loading,
      title,
      groupTitle,
      fpId,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      areOptionsLoaded,
      planImpactItems,
      purchasePrice,
    } = this.props;
    const { ADV } = window;
    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <AdvForm>
            <ValidationErrors clientId={clientId} />
            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>
              <li className="what-ifs-large-purchase-price-form-field">
                <AdvInputWrapper hasCurrency className="what-ifs-input-wrapper">
                  <AdvInput
                    autoComplete="off"
                    type="text"
                    dataType="money"
                    maxLength="14"
                    onBlur={this.onPriceBlur}
                    value={ADV.util.formatValue(purchasePrice, 'money')}
                    className="what-ifs-input"
                  />
                </AdvInputWrapper>
              </li>
            </ul>
          </AdvForm>
        </div>
        <PlanImpact clientId={clientId} planImpactItems={planImpactItems} />
        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}
PriceChangesChangesView.defaultProps = {
  title: 'Untitled What If',
  groupTitle: 'Untitled What If Group',
};

PriceChangesChangesView.propTypes = {
  planImpactItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    current: PropTypes.string.isRequired,
    proposed: PropTypes.string.isRequired,
  })).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  purchasePrice: createCustomPropType(isNumericFormatted).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  storeData: PropTypes.func.isRequired,
};

export default PriceChangesChangesView;
